import { type User as Auth0User } from '@auth0/auth0-react'
import { atom } from 'jotai'

export const auth0UserAtom = atom<Auth0User | undefined>(undefined)
